import React from "react";
import DateTime from "react-datetime";
import { formatDate, parseDate } from "react-day-picker/moment";
import moment from "moment";

const CustomDateTime = ({
  name = null,
  format = "YYYY-MM-DD",
  value = "",
  placeholder = "Date",
  timeFormat = false,
  onChange,
  onChangeDate,
  inputProps,
  disabled = false,
  isValidDate = () => true,
  renderInput = "",
  closeOnSelect = false,
  readOnly = false,
  timeConstraints = false,
  initialViewDate,
  className,
}) => {
  const handleOnChange = (date) => {
    if (onChange) onChange(date, name);

    if (onChangeDate)
      onChangeDate({
        target: {
          name,
          value: date instanceof moment ? date.format("YYYY-MM-DD") : "",
        },
      });
  };

  return (
    <DateTime
      formatDate={formatDate}
      parseDate={parseDate}
      timeFormat={timeFormat}
      dateFormat={["DD-MM-YYYY", "YYYY-MM-DD"].includes(format) ? "DD-MM-YYYY" : format}
      name={name}
      value={["DD-MM-YYYY", "YYYY-MM-DD"].includes(format) ? moment(value) : value}
      //   onChange={(moment) => onChange?.(moment, name)}
      onChange={handleOnChange}
      inputProps={
        inputProps || {
          placeholder,
          disabled,
          readOnly,
        }
      }
      isValidDate={isValidDate}
      renderInput={renderInput}
      closeOnSelect={closeOnSelect}
      timeConstraints={timeConstraints}
      className={className || ""}
    />
  );
};

export default CustomDateTime;
